var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer',{ref:"viewer",attrs:{"options":_vm.defaultOptions,"images":_vm.images},on:{"inited":_vm.inited}},_vm._l((_vm.images),function(src,index){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],key:index,attrs:{"src":src}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80b14346","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/previewPicture/index.vue
// module id = null
// module chunks = 